<script>

import debounce from "buefy/src/utils/debounce.js";

export default {
    data() {
        return {
            loading: false,
            loadingEmployees: false,
            errors: {
                amount: null,
                terms: null,
            },
            termsAccepted: false,
            employees: [],
            success: false,
            selectedEmployee: null,
            amount: 0,
            value: null,
            currency: '',
            comments: '',
            controller: {
                load: null
            }
        }
    },

    methods: {
        submit() {
            if (!this.termsAccepted) {
                this.errors.terms = this.$t('messages.agreement_required');
                return;
            }
            this.loading = true;
            axios.post('/token-transactions', {
                receiver_id: this.selectedEmployee.id,
                amount: parseInt(this.amount),
                currency: this.currency,
                comments: this.comments,
                value: this.value,
            }).then(response => {
                this.$emit('minted', response.data.data);
                this.$toast.success(this.$t('token_transactions.messages.tokens_sent'));
                this.selectedEmployee = null;
                this.success = true;
                this.close();
            }).catch(error => {
                if (error.response && error.response.data && error.response.data.errors) {
                    this.errors = error.response.data.errors;
                }
            }).finally(() => {
                this.loading = false;
            })
        },
        close() {
            this.$emit('close', {requestSent: this.success});
        },
        onTyping(search) {
            this.employees = [];
            if (search.length < 1) {
                return;
            }
            this.loadingEmployees = true;
            this.loadEmployeesDebounce(search);
        },
        loadEmployeesDebounce: debounce(function (search) {
            this.loadEmployees(search);
        }, 500),
        loadEmployees(search) {
            if (this.controller.load) {
                this.controller.load.abort();
            }
            this.controller.load = new AbortController();
            this.loadingEmployees = true;
            axios.get('/users/employees',{
                signal: this.controller.load.signal,
                params: {
                    search: search,
                    sort: 'last_name',
                    order: 'asc'
                }
            }).then(response => {
                this.employees = response.data.data;
            }).catch(error => {
            }).finally(() => {
                this.loadingEmployees = false;
            })
        }
    }
};
</script>

<template>
    <section>
        <div class="modal is-active">
            <div class="modal-background"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">{{ $t('token_transactions.labels.send_tokens') }}</p>
                    <button class="delete" aria-label="close" @click="close"></button>
                </header>
                <div class="modal-card-body">

                    <b-field :label="$t('employees.labels.search_employee')">
                        <b-autocomplete
                            :data="employees"
                            :placeholder="$t('employees.labels.search_employee_placeholder')"
                            field="title"
                            :loading="loadingEmployees"
                            @typing="onTyping"
                            @select="option => selectedEmployee = option">
                            <template #empty>
                                <span v-if="!loadingEmployees">{{ $t('messages.no_results') }}</span>
                                <span v-if="loadingEmployees">{{ $t('messages.searching') }}</span>
                            </template>

                            <template v-slot="props">
                                {{ props.option.first_name }} {{ props.option.last_name }} | {{ props.option.email }} <span v-if="props.option.pesel">| {{ props.option.pesel }}</span>
                            </template>
                        </b-autocomplete>
                    </b-field>
                    <div v-if="selectedEmployee" class="block">
                        <div class="message is-link">
                            <div class="message-header">
                                <p>{{ $t('employees.labels.selected_employee') }}</p>
                                <button class="delete" @click="selectedEmployee = null" aria-label="delete"></button>
                            </div>
                            <div class="message-body">
                                <p class="has-text-weight-bold">{{ selectedEmployee.first_name }} {{ selectedEmployee.last_name }}</p>
                                <p>{{ selectedEmployee.email }}</p>
                            </div>
                        </div>
                        <div class="block">
                            <b-field :label="$t('token_transactions.fields.amount_to_send.name')"
                                     :type="errors.amount ? 'is-danger' : null"
                                     :message="errors.amount ? errors.amount[0] : null">
                                <b-input
                                    v-model="amount"
                                    icon="cash"
                                ></b-input>
                            </b-field>
                            <b-field :label="$t('token_transactions.fields.value.name')"
                                     :type="errors.value ? 'is-danger' : null"
                                     :message="errors.value ? errors.value[0] : null">
                                <b-input
                                    v-model="value"
                                    icon="cash-multiple"
                                ></b-input>
                            </b-field>
                            <b-field :label="$t('token_transactions.fields.currency.name')"
                                     :type="errors.currency ? 'is-danger' : null"
                                     :message="errors.currency ? errors.currency[0] : null">
                                <b-input
                                    v-model="currency"
                                    icon="currency-usd"
                                ></b-input>
                            </b-field>
                            <b-field :label="$t('token_transactions.fields.comments.name')"
                                     :type="errors.comments ? 'is-danger' : null"
                                     :message="errors.comments ? errors.comments[0] : null">
                                <b-input
                                    type="textarea"
                                    v-model="comments"
                                ></b-input>
                            </b-field>
                        </div>

                        <div class="field">
                            <label class="checkbox">
                                <input type="checkbox" v-model="termsAccepted"/>
                                {{ $t('token_transactions.agreements.token_charge_agreement') }}
                            </label>
                            <p v-if="errors.terms" class="help is-danger">
                                {{ errors.terms }}
                            </p>
                        </div>
                    </div>

                </div>
                <footer class="modal-card-foot">
                    <div class="buttons">
                        <b-button @click="submit()"
                                :disabled="loading || !selectedEmployee || token_amount <= 0 || !termsAccepted"
                                :loading="loading"
                                type="is-success">
                            {{ $t('actions.send') }}
                        </b-button>
                        <b-button @click="close">
                            {{ $t('actions.cancel') }}
                        </b-button>
                    </div>
                </footer>
            </div>
        </div>
    </section>
</template>
<style scoped>
.modal-card {
    min-height: 500px;
}
</style>
